"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientTag_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var Patient_1 = require("./Patient");
var PatientTagType_1 = require("./PatientTagType");
var PatientTag_Factory = /** @class */ (function () {
    function PatientTag_Factory() {
    }
    PatientTag_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CreatedByUser: User_1.User_Factory.CreateIncoming(model.CreatedByUser),
            CreatedByUserId: model.CreatedByUserId,
            Patient: Patient_1.Patient_Factory.CreateIncoming(model.Patient),
            PatientId: model.PatientId,
            PatientTagType: PatientTagType_1.PatientTagType_Factory.CreateIncoming(model.PatientTagType),
            PatientTagTypeId: model.PatientTagTypeId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RemovedByUser: User_1.User_Factory.CreateIncoming(model.RemovedByUser),
            RemovedByUserId: model.RemovedByUserId,
        };
        return result;
    };
    PatientTag_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CreatedByUser: User_1.User_Factory.CreateOutgoing(model.CreatedByUser),
            CreatedByUserId: model.CreatedByUserId,
            Patient: Patient_1.Patient_Factory.CreateOutgoing(model.Patient),
            PatientId: model.PatientId,
            PatientTagType: PatientTagType_1.PatientTagType_Factory.CreateOutgoing(model.PatientTagType),
            PatientTagTypeId: model.PatientTagTypeId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RemovedByUser: User_1.User_Factory.CreateOutgoing(model.RemovedByUser),
            RemovedByUserId: model.RemovedByUserId,
        };
        return result;
    };
    return PatientTag_Factory;
}());
exports.PatientTag_Factory = PatientTag_Factory;
